import actions from "./actions";
// eslint-disable-next-line import/no-cycle
import {updateReducer} from "./helper/updateReducer";
// eslint-disable-next-line import/no-cycle
import {getInitData} from "./helper/getInitData";
// import {update} from "immutable";

export const L = {
    company_addresses: 'company_addresses',
    contact_addresses: 'contact_addresses',
    contact_persons: 'contact_persons',
    countries: 'countries',
    state_list: 'state_list', // country state list
    currencies: 'currencies',
    contact_groups: 'contact_groups',
    contacts: 'contacts',
    // products: 'products',
    accounts: 'accounts',
    terms: 'terms',
    tag_groups: 'tag_groups',
    asset_types: 'asset_types',
    fields: 'fields',
    number_formats: 'number_formats',
    locations: 'locations',
    tax_codes: 'tax_codes',
    settings: 'settings',
    // limits: 'limits',
    users: 'users',
    price_levels: 'price_levels',
    payment_methods: 'payment_methods',
    advisors: 'advisors',
    product_list: 'product_list', // previously products
    product_detail: 'product_detail', // previously product
    product_detail_list: 'product_detail_list',
    product_groups: 'product_groups',
    classification_code_list: 'classification_code_list',
    form_designs: 'form_designs',
    clients: 'clients', // used for partner portal, event logs page Client filter

    flow_streams: 'flow_streams',
};

const initState = {
    readListsState: null,
    queue: {
        pending: [], // Array of { lists, params, requesterId, showSpinner, forceMode }
        completedIds: [], // Array of requesterIds
        readyLists: [],
        url: '/',
    },
    readReconciliationsState: false,
    reconciliations: [],
    ...Object.keys(L).reduce((accum, key) => ({...accum, ...getInitData(key)}), {}),
};

export default function authReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.LIST_READ_LISTS_REQUEST: {
            const { lists, params, requesterId, showSpinner, forceMode } = action;
            // console.log('qq LIST_READ_LISTS_REQUEST', {lists, requesterId, forceMode});

            // If navigated to a new page, => clear 'completed'
            const { pathname } = window.location;
            // console.log('qq LIST_READ_LISTS_REQUEST 1', {lists,
            //     requesterId,
            //     pathname,
            //     queueUrl: state.queue.url,
            // });

            // console.log('qq LIST_READ_LISTS_REQUEST 1', {lists,
            //     requesterId,
            //     pathname,
            //     queueUrl: state.queue.url,
            //     // location,
            //     // history,
            // });

            const pending = [...state.queue.pending, { lists, params, requesterId, showSpinner, forceMode }];
            const completedIds = pathname !== state.queue.url ? [] : [...state.queue.completedIds];
            const readyLists = pathname !== state.queue.url ? [] : [...state.queue.readyLists];
            const url = pathname;

            // console.log('qq LIST_READ_LISTS_REQUEST 2', {lists,
            //     pending,
            //     completedIds,
            //     readyLists,
            //     url,
            // });
            return {
                ...state,
                readListsState: 'request',
                queue: {
                    pending,
                    completedIds,
                    readyLists,
                    url,
                },
            };
        }
        case actions.LIST_READ_LISTS_SUCCESS: {
            const { lists, responseData, params, requesterIds } = action;

            // console.log('qq LIST_READ_LISTS_SUCCESS 1', {
            //     lists,
            //     responseData,
            //     params,
            //     requesterIds,
            // });

            // Queue
            const completedIds = [...state.queue.completedIds, ...requesterIds];
            const readyLists = [...new Set([...state.queue.readyLists, ...lists])];
            const pending = state.queue.pending.filter(
                ({ requesterId }) => !completedIds.includes(requesterId),
            );
            // console.log('qq LIST_READ_LISTS_SUCCESS', lists, completedIds);

            // console.log('qq LIST_READ_LISTS_SUCCESS 2', {
            //     completedIds,
            //     readyLists,
            //     pending,
            // });

            return {
                ...state,
                ...lists.reduce(
                    (accum, key) => ({ ...accum, ...updateReducer(key, responseData, params) }), {},
                ),
                readListsState: 'success',
                queue: {
                    pending,
                    completedIds,
                    readyLists,
                    url: state.queue.url,
                },
            };
        }
        case actions.LIST_READ_LISTS_FAILURE: {
            const { requesterIds } = action;

            const pending = state.queue.pending.filter(
                ({ requesterId }) => !requesterIds.includes(requesterId),
            );

            return {
                ...state,
                readListsState: false,
                queue: {
                    ...state.queue,
                    pending,
                },
            };
        }
        case actions.LIST_RESET_LISTS: {
            const { lists } = action;
            return {
                ...state,
                ...lists.reduce((accum, key) => ({...accum, ...getInitData(key)}), {}),
            };
        }
        case actions.LIST_READ_RECONCILIATIONS_REQUEST:
            return {
                ...state,
                readReconciliationsState: 'request',
            };
        case actions.LIST_READ_RECONCILIATIONS_SUCCESS:
            return {
                ...state,
                readReconciliationsState: 'success',
                reconciliations: action.reconciliations,
            };
        case actions.LIST_ADD_CONTACT:
            return {
                ...state,
                contacts: [...state.contacts, action.contact],
            };
        case actions.LIST_REPLACE_CONTACT: {
            const contacts = [...state.contacts];
            const updateIndex = contacts.findIndex(c => c.id === action.contact.id);
            contacts[updateIndex] = action.contact;
            return {
                ...state,
                contacts,
            };
        }
        case actions.LIST_REPLACE_CONTACT_ADDRESSES:
            return {
                ...state,
                contactAddresses: action.contactAddresses,
            };
        case actions.LIST_REPLACE_CONTACT_PERSONS:
            return {
                ...state,
                contactPersons: action.contactPersons,
            };
        case actions.LIST_REPLACE_PRODUCT_DETAIL_LIST:
            return {
                ...state,
                productDetailList: action.productDetailList,
            };
        case actions.LIST_MERGE_PRODUCT_DETAIL_LIST:
            return {
                ...state,
                productDetailList: [...state.productDetailList, ...action.productDetailList],
            };
        case actions.LIST_ADD_PRODUCT:
            return {
                ...state,
                // products: [...state.products, action.product],
                productList: [...state.productList, action.product],
            };
        case actions.LIST_ADD_ACCOUNT:
            if (!action.account.parent_id) {
                return {
                    ...state,
                    accounts: [...state.accounts, action.account],
                };
            }
            return {
                ...state,
                accounts: state.accounts.map(item => {
                    if (item.id !== action.account.parent_id)
                        return item;
                    return {
                        ...item,
                        children: [...item.children, action.account],
                    };
                }),
            };
        case actions.LIST_ADD_TERM:
            return {
                ...state,
                terms: [...state.terms, action.term],
            };
        case actions.LIST_ADD_LOCATION:
            return {
                ...state,
                locations: [...state.locations, action.location],
            };
        case actions.LIST_ADD_PAYMENT_METHOD:
            return {
                ...state,
                paymentMethods: [...state.paymentMethods, action.paymentMethod],
            };
        case actions.LIST_ADD_PRICE_LEVEL:
            return {
                ...state,
                priceLevels: [...state.priceLevels, action.priceLevel],
            };
        case actions.LIST_ADD_NUMBER_FORMAT:
            return {
                ...state,
                numberFormats: [...state.numberFormats, action.numberFormat],
            };
        case actions.LIST_ADD_TAG: {
            const newTagGroups = state.tagGroups.map(group => {
                if (group.id === action.tag.tag_group_id) {
                    return {
                        ...group,
                        tags: [...group.tags ?? [], action.tag],
                    };
                }
                return group;
            });

            return {
                ...state,
                tagGroups: newTagGroups,
            };
        }
        case actions.LIST_ADD_TAG_GROUP:
            return {
                ...state,
                tagGroups: [...state.tagGroups, action.tagGroup],
            };
        case actions.LIST_ADD_FLOW_STREAM:
            return {
                ...state,
                flowStreams: [...state.flowStreams, action.flowStream],
            };
        case actions.LIST_CHANGE_FLOW_STEAMS:
            return {
                ...state,
                flowStreams: action.flowStreams,
            };
        case actions.READ_ALL_PRODUCT_AND_PRODUCT_DETAIL_LIST:
            return {
                ...state,
            };
        // case actions.LIST_UPDATE_LIMITS:
        //     return {
        //         ...state,
        //         limits: {...state.limits, [action.key]: action.limits},
        //     };
        case actions.ADD_ROUTED_PATH:
            return {
                ...state,
                queue: {
                    ...state.queue,
                    readyLists: [], // remove cache once page has changed - https://bukku.atlassian.net/browse/ENG-3085
                },
            };
        default:
            return state;
    }
}
